// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyABxJEQZDvc6XdtOE8rIlQgBmUtLoCQoBM",
  authDomain: "luma-1901.firebaseapp.com",
  projectId: "luma-1901",
  storageBucket: "luma-1901.firebasestorage.app",
  messagingSenderId: "450626308811",
  appId: "1:450626308811:web:fbfade4c0e83e7e640294e",
  measurementId: "G-N8T1FWZSYT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, signInWithPopup, signOut, db };